export * from './consultation.model';
export * from './consultation.service';
export * from './consultation.slice';
